import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdSyncAlt } from "react-icons/md";

import { useDispatch, useSelector } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import { apiGetInstance } from "../../api/ApiInstance";
import { Modal, Spinner } from "react-bootstrap";

const ComponentFastSwitchInstance = () => {
  const { t } = useTranslation();
  const { ReduxUserEmail, ReduxInstancesAutorisees } = useSelector((state) => state.ReduxUser);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const dispatch = useDispatch();
  const [ReduxInstancesPossibles, setReduxInstancesPossibles] = useState([]);
  const [show, setShow] = useState(false);
  const [showBascule, setShowBascule] = useState(false);

  const changeInstanceLive = async (id, nom) => {
    setShow(false);
    setShowBascule(nom);
    window.setTimeout(async function () {
      const res = await apiGetInstance(id, ReduxUserEmail);
      dispatch(chgInstance(res.data));
      setShowBascule(false);
    }, 1000); //6000
  };

  useEffect(() => {
    const newArray = ReduxInstancesAutorisees.filter((item) => item._id !== ReduxInstance._id);
    setReduxInstancesPossibles(newArray);
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {ReduxInstancesPossibles.length >= 1 && (
        <div
          className="containerChangeInstanceLive persoBackColor"
          role="button"
          onClick={() =>
            ReduxInstancesPossibles.length === 1
              ? changeInstanceLive(
                  ReduxInstancesPossibles[0]._id,
                  ReduxInstancesPossibles[0].entite
                )
              : setShow(true)
          }
        >
          <MdSyncAlt size="1.5em" />
        </div>
      )}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("public.switchInstance.modalTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {ReduxInstancesPossibles.map((instance) => (
            <div
              role="button"
              key={instance._id}
              onClick={() => changeInstanceLive(instance._id, instance.entite)}
            >
              - {instance.entite}
            </div>
          ))}
        </Modal.Body>
      </Modal>
      <Modal
        show={showBascule}
        onHide={() => setShowBascule(false)}
        centered
        fullscreen={true}
        className="modalSwitchInstance"
      >
        <Modal.Body className="text-center">
          <br />
          <span className="fw-bold">"{showBascule}"</span>
          <br /> {t("public.switchInstance.modalChargement")} <br />
          <br />
          {t("public.switchInstance.modalPatienter")}
          <br />
          <br />
          <Spinner animation="border" />
          <br />
          <br />
          <br />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ComponentFastSwitchInstance;
